import { client } from "@lib";
import imageUrlBuilder from "@sanity/image-url";
import PropTypes from "prop-types";
import React from "react";

import * as styles from "./Figure.module.scss";

const builder = imageUrlBuilder(client);

export function Figure({ value }) {
  const { alt, caption, asset } = value;
  if (!asset) {
    return undefined;
  }
  return (
    <figure className={styles.root}>
      <img
        src={builder.image(asset).auto("format").width(2000).url()}
        className={styles.image}
        alt={alt}
      />
      {caption && (
        <figcaption>
          <div className={styles.caption}>
            <div className={styles.captionBox}>
              <p>{caption}</p>
            </div>
          </div>
        </figcaption>
      )}
    </figure>
  );
}

Figure.propTypes = {
  node: PropTypes.shape({
    alt: PropTypes.string,
    caption: PropTypes.string,
    asset: PropTypes.shape({
      _ref: PropTypes.string,
    }),
  }),
};
